export default {
	WorkingEnvironment: 'WEV',
	OrgaDiagnosis: 'ODG',
	OrgaCultureInventory: 'OCI',
};



// WEBPACK FOOTER //
// ./src/shared/tools-codes.js